import React from 'react';
import Img from 'react-image';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames/bind';

import styles from './join.module.scss';
import joinImg from '../../img/join.jpg';

let cx = classNames.bind(styles);

const Join = () => {
	const { t } = useTranslation();

	return (
		<section id='join' className={cx({ join: true })}>
			<div className='flex flex-col lg:flex-row w-full'>
				<div className='flex flex-col w-full lg:w-1/2'>
					<Img src={joinImg} className='w-full' />
				</div>
				<div className='flex flex-col w-full lg:w-1/2 bg-white p-10 lg:py-32 lg:pl-16 lg:pr-32 lg:justify-center'>
					<h1 className='font-HelveticaNeueLTStd-Bold text-telus-purple text-2xl lg:text-3xl py-4'>
						Join our caring culture
					</h1>
					<p className='font-HelveticaNeueLTStd-Roman text-telus-dark text-xl lg:text-2xl pb-4'>
						We’re always looking for talented individuals to join our family.
					</p>
					<p className='font-HelveticaNeueLTStd-Roman text-telus-dark text-xl lg:text-2xl pb-4'>
						Join a company that appreciates your energy, drive and enthusiasm just as much as your skills. The majority of our directors and managers started their careers as agents or IT developers. And yes, we offer competitive salaries and benefits. But even better – it’s our caring culture that defines who we are and why you’ll want to become part of our family. As we say, it’s different here at TELUS International.
					</p>
				</div>
			</div>
		</section>
	);
};

export default Join;
